<template>
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="#059669"/>
    <path d="M17 25L21 29L31 19" stroke="#FFFFFF" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>    
</template>
<script>
export default {
  name: "Check"
}
</script>
<style lang="scss" scoped>
</style>